/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Component, OnInit, Inject } from "@angular/core";
import { ProfileResponse } from "../../auth-feature/models/userRequestResponse.interface";
import { ReviewService } from "../../../services/productFeatureServices/review.service";
import { ReveiwDetails, RatingsBack } from "../../../models/review.interface";
import { ProductId } from "../../product-feature/models/product-home-interface";
import { Router } from "@angular/router";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ChangePasswordComponent } from "../../auth-feature/change-password/change-password.component";
import { SignInService } from "../../auth-feature/authServices/signin.service";
import { EditProfileComponent } from "../edit-profile/edit-profile.component";
import { CheckImageUrlService } from "src/app/check-image-url.service";
import { ProductService } from "../../../features/product-feature/services/product.service";
import { ProductHomeService } from "../../../features/product-feature/product-home/product-home.service";

@Component({
  selector: "app-user-profile",
  templateUrl: "./user-profile.component.html",
  styleUrls: ["./user-profile.component.scss"],
})
export class UserProfileComponent implements OnInit {
  user: ProfileResponse;
  // favorites = ['assets/images/img1.png', 'assets/images/img2.png', 'assets/images/img3.png'];
  color = "black";
  contact = "";
  email = "";
  profilePic = "";
  name = "";
  view = false;
  reviewId: any;
  reviewsResult: RatingsBack;
  reviewDetails: any;
  noOfReviews: number;
  lastDate: any;
  finalStar: any;
  finalStarRate: any;
  inventoryId: string;
  productId: ProductId;
  reviewDetailsNew = [];
  currentCount = 0;
  reviewCount = 0;
  productImage = 0;
  pageNumber = 1;
  edit = false;
  images = [];
  // dataObj =[{ 'gallery': {'images': [], 'videos': []}}];
  dataObj: any;
  favourites = { gallery: { images: [], videos: [] } };
  constructor(
    private reviewService: ReviewService,
    private router: Router,
    private dialog: MatDialog,
    private signInService: SignInService,
    private checkUrl: CheckImageUrlService,
    private productService: ProductService,
    private productHomeService: ProductHomeService
  ) {
    // this.profile = this.user.profileImage;
    // this.contact = this.user.email;
    // this.name = this.user.userName;ch
  }

  ngOnInit() {
    if (!localStorage.getItem("nVipaniwhiteshopkey")) {
      this.router.navigateByUrl("");
    }
    this.dataObj = [{ gallery: { images: [], videos: [] } }];
    this.productHomeService.throwUpdatedUser.subscribe((res) => {
      if (Object.keys(res).length) {
        this.name = res.displayName;
        if (res.email) {
          this.email = res.email;
        }
        if (res.mobile) {
          this.contact = res.mobile;
        }
      }
    });
    this.productService.getFavourite().subscribe((data) => {
      console.log("this is favourites");
      console.log(data);
      this.dataObj = data;
      this.productHomeService.throwFavourites.next(this.dataObj);
      if (this.dataObj.length) {
        for (let i = 0; i < this.dataObj.length; i++) {
          for (let j = 0; j < this.dataObj[i].gallery.images.length; j++) {
            this.favourites.gallery.images[j] = this.dataObj[i].gallery.images[
              j
            ];
          }
          this.images[i] = {
            images: this.dataObj[i].gallery.images[0].thumbnailImageURL,
            inventoryGroupId: this.dataObj[i]._id,
          };
        }
      }
      for (let i = 0; i < this.dataObj.length; i++) {
        for (let j = 0; j < this.dataObj[i].gallery.videos.length; j++) {
          this.favourites.gallery.videos[j] = this.dataObj[i].gallery.videos[j];
        }
      }
      console.log(this.favourites);
    });
    this.pageNumber = 1;
    this.currentCount = 0;
    this.reviewCount = 0;
    this.reviewDetailsNew = [];
    this.getReviews(this.pageNumber);
  }
  getReviews(page) {
    if (!this.currentCount || this.currentCount < this.reviewCount) {
      this.pageNumber = page;
      this.reviewService.fetchReviewsForUser(page).subscribe((res) => {
        console.log("this is the result");
        this.reviewsResult = res;
        const request: any = { email: "", phone: "", name: "" };
        if (this.reviewsResult.reviews[0].source.email) {
          this.email = this.reviewsResult.reviews[0].source.email;
          request.email = this.email;
        }
        if (this.reviewsResult.reviews[0].source.mobile) {
          this.contact = this.reviewsResult.reviews[0].source.mobile;
          request.phone = this.contact;
        }
        this.name = this.reviewsResult.reviews[0].source.displayName;
        request.name = this.name;
        this.signInService.sendUserDataFromProfilePage(request);
        console.log(this.reviewsResult.reviews[0].source.profileImageURL);
        this.profilePic = this.checkUrl.verifyImage(
          this.reviewsResult.reviews[0].source.profileImageURL
        );
        console.log(this.profilePic);

        console.log(res);
        this.reviewDetails = this.reviewsResult;
        this.reviewCount = res.totalCount;
        this.reviewDetailsNew = this.reviewDetailsNew.concat(
          this.reviewDetails
        );
        this.currentCount = this.reviewDetailsNew.length;
      });
    }
  }

  editProfile() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = false;
    dialogConfig.hasBackdrop = true;
    dialogConfig.maxWidth = "100vw";
    dialogConfig.width = "100vw";
    dialogConfig.panelClass = "override";
    dialogConfig.position = {
      top: "0",
      left: "0",
    };
    this.dialog.open(EditProfileComponent, dialogConfig);
  }

  changePassword() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = false;
    dialogConfig.hasBackdrop = true;
    dialogConfig.maxWidth = "100vw";
    dialogConfig.width = "100vw";
    dialogConfig.panelClass = "override";
    dialogConfig.position = {
      top: "0",
      left: "0",
    };
    this.dialog.open(ChangePasswordComponent, dialogConfig);
  }
}
